export default function () {
    return function (data) {
        if (data.name) {
            return data.name;
        }

        let dimensions = [data.height, data.width, data.length].join('x');

        return `${dimensions} (${data.weight} Kg)`;
    }
}
